<template>
  <div>
    <div class="message__try animate__animated animate__fadeInUp animate__faster">
      {{ $i18nPresenter.t('Try') }}:
    </div>
    <div v-for="(suggestion, suggestionIndex) in promptSuggestions" :key="suggestionIndex">
      <aha-tag
        v-aha-emit-action="{user_input: suggestion}"
        class="message__suggestion animate__animated animate__fadeInUp animate__faster"
        tabindex="0"
        @click="onClickSuggestion(suggestion)"
        name="ai_prompt_suggestion"
      >
        ✨ {{ suggestion }}
      </aha-tag>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    promptSuggestions: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    onClickSuggestion(suggestion) {
      this.$emit('clickOnSuggestion', suggestion)
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.message__try {
  @apply text-sm mb-2 break-words;
  color: #545454;
  animation-delay: 0.3s;
}
.message__suggestion {
  @apply w-max mb-2 text-sm cursor-pointer break-words whitespace-normal text-left;
  max-width: calc($right-panel-width - ($right-panel-content-px * 2));
  animation-delay: 0.6s;
  transition: 0.2s ease-in-out;
}
</style>
